<template>
  <svg
    class="d-block"
    xmlns="http://www.w3.org/2000/svg"
    style="aspect-ratio: 1920 / 70"
    viewBox="0 0 1920 70"
    fill="none"
  >
    <path
      d="M0 34.9484C359.673 81.868 569.85 78.5026 960 34.9484C1314.94 -12.1839 1525.58 -11.1117 1920 34.9484V417H0V34.9484Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#2C4C9B",
    },
  },
};
</script>
